<template>
    <div>
        <div class="vx-flex vx-gap-2 vx-mb-3 lg:vx-mb-4">
            <div class="vx-grow"
                data-test="value-wrapper">
                <select-group v-if="props.groupSelect"
                    :error="displayFirstError(validate.value) || displayFirstError(validate.values)"
                    placeholder="group"
                    v-model="value"
                    @option:selected="add()">
                </select-group>
                <vx-input v-else
                    placeholder="enter a value"
                    v-model="value"
                    @keypress.enter.prevent="add()"
                    :error="displayFirstError(validate.value) || displayFirstError(validate.values)">
                    <template v-slot:right>
                        <vx-button @click.prevent="add()"
                            data-test="add"
                            color="transparent"
                            type="button"
                            class="-vx-mr-4">
                            <font-awesome-icon :icon="faCirclePlus"></font-awesome-icon>
                        </vx-button>
                    </template>
                </vx-input>
            </div>
        </div>

        <div class="vx-pl-4">
            <vx-list-animated v-model="values"></vx-list-animated>
        </div>
    </div>
</template>

<script setup>
import { faCirclePlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton, VxInput, VxListAnimated } from '@voxie/frontend-components';
import useVuelidate from '@vuelidate/core';
import { helpers, maxLength, minLength, required, requiredIf } from '@vuelidate/validators';
import { computed, ref } from 'vue';
import { csvInjection, customAttributeValue, displayFirstError } from '~/utils/validation';
import SelectGroup from '~/components/general/SelectGroup.vue';

const value = ref('');

const values = defineModel({
    type: Array,
    required: true,
    default: () => ([])
});

const props = defineProps({
    groupSelect: {
        type: Boolean,
        default: false,
    }
})

const validate = useVuelidate({
    value: {
        requiredIf: helpers.withMessage('Value is required', requiredIf(() => values.value.length === 0)),
        customAttributeValue: customAttributeValue,
        csvInjection: csvInjection,
    },
    values: {
        required: helpers.withMessage('You need to add at least one value', required),
        minLength: minLength(1),
        maxLength: maxLength(50),
    }
}, computed(() => ({ value: value, values: values })));

const add = async () => {
    const isValid = await validate.value.value.$validate();
    if (!isValid) {
        return;
    }
    if (values.value.find(existingValue => existingValue === value.value)){
        value.value = '';
        return;
    }

    values.value.push(value.value);
    value.value = '';
}

</script>
